import {IAvailableFilter} from "../items/interface/Item.interface";
import {
  IProductListFilterItem,
  ProductListFilterItemValueType,
  ProductListFilterItemType,
} from "./ProductListFilterItem";
import {ProductListFilterItemSelect} from "./ProductListFilterItemSelect";
import {ProductListFilterItemBoolean} from "./ProductListFilterItemBoolean";
import {ProductListFilterItemRange} from "./ProductListFilterItemRange";

export class ProductListFilter {
  public readonly filterItems: Map<string, IProductListFilterItem> = new Map();

  /**
   * Get all request params depending on filter item values.
   */
  public get requestParams(): {[k: string]: string} {
    const result: {[k: string]: string} = {};
    for (const item of this.filterItems.values()) {
      const paramValue = item.paramValue;

      if (paramValue !== "") {
        result[item.field] = paramValue;
      }
    }

    return result;
  }

  /**
   * Create FilterItem by request result available filter item.
   * @param filterItemData
   */
  private static createFilterItem(filterItemData: IAvailableFilter): IProductListFilterItem | undefined {
    switch (filterItemData.type) {
      case ProductListFilterItemType.select:
        return new ProductListFilterItemSelect(filterItemData);
      case ProductListFilterItemType.boolean:
        return new ProductListFilterItemBoolean(filterItemData);
      case ProductListFilterItemType.range:
        return new ProductListFilterItemRange(filterItemData);
      default:
        return undefined;
    }
  }

  public applyFilterValue(filterValues: {[k: string]: ProductListFilterItemValueType}) {
    for (const [field, filterItem] of this.filterItems) {
      if (filterValues[field]) {
        filterItem.value = filterValues[field];
      } else {
        filterItem.clear();
      }
    }
  }

  public applyFilterResult(filterResults: IAvailableFilter[]): void {
    const updatedFilterItem = new Set();

    for (const filterResult of filterResults) {
      const filterResultItem = this.filterItems.get(filterResult.field);

      if (filterResultItem) {
        filterResultItem.count = filterResult.count;
        filterResultItem.applyFilterItemValueResult(filterResult.values);
      } else {
        this.addFilterItem(filterResult);
      }
      updatedFilterItem.add(filterResult.field);
    }

    for (const filterItem of this.filterItems.values()) {
      // Just update filter item that not updated yet.
      if (!updatedFilterItem.has(filterItem.field)) {
        filterItem.disable();
      }
    }
  }

  /**
   * Create new filter item and add it to filter item list (if valid)
   * @param itemData
   * @private
   */
  private addFilterItem(itemData: IAvailableFilter) {
    const item = ProductListFilter.createFilterItem(itemData);

    if (item !== undefined) {
      this.filterItems.set(item.field, item);
    }
  }
}
